import { sortBy, startCase } from "lodash";
import { ISelectOption } from "shared/models";

export enum UserRoles {
  Owner = "owner",
  ProgramManager = "program_manager",
  AuditAdministrator = "audit_admin",
  ContractorOps = "contractor_ops",
  Engineer = "engineer",
  OperationsManager = "operations_manager",
  FinanceManager = "finance_manager",
  SalesRep = "sales_rep",
  FieldAuditor = "field_auditor",
  Subcontractor = "subcontractor",
}

export enum TenantRoles {
  Owner = "owner",
  Admin = "admin",
  Viewer = "viewer",
}

export const TenantRoleSelectOptions = (): ISelectOption[] => {
  const options: ISelectOption[] = [];

  for (const key in TenantRoles) {
    if (Object.prototype.hasOwnProperty.call(TenantRoles, key)) {
      options.push({
        label: startCase(key),
        value: (TenantRoles as any)[key],
      });
    }
  }

  return sortBy(options, (o) => o.label);
};

export const UserRoleSelectOptions = () => {
  let options: ISelectOption[] = [];

  for (const key in UserRoles) {
    if (Object.prototype.hasOwnProperty.call(UserRoles, key)) {
      options.push({
        label: startCase(key),
        value: (UserRoles as any)[key],
      });
    }
  }

  return sortBy(options, (o) => o.label);
};
